import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManageStatesRaw = React.lazy(() => import(/* webpackChunkName: "AdminManageStatesPage" */ './Page'));
export const AdminManageStates = () => (React.createElement(Page, { title: "Administrator Manage States" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminManageStatesRaw, null)))));
